module.exports = __webpack_public_path__ + "static/media/login-photo.0f433e7e.png";